import { twMerge } from 'tailwind-merge';
import OptionLabel from 'src/components/admin/form/OptionLabel';

type OrgNameCellProps = {
   name?: string | null;
   /** A chapter's parent club, smaller and gray under the name (NPT-2274/2278). */
   parentName?: string | null;
   className?: string;
   nameClassName?: string;
};

/**
 * NPT-2278 — an org name in an admin table or list, with a chapter's club under it,
 * so twenty "2033 Yellow" rows from different clubs can be told apart. Both lines wrap
 * like the plain names they replaced; a long club name is never cut off.
 */
const OrgNameCell = ({ name, parentName, className, nameClassName = 'font-semibold text-black' }: OrgNameCellProps) => (
   <span className={twMerge('flex min-w-0 flex-col', className)}>
      <span className={twMerge('break-words', nameClassName)}>{name}</span>
      {parentName && <span className="break-words text-xs font-normal text-gray-500">{parentName}</span>}
   </span>
);

/** The same, inline: the club smaller and gray right after the name — the pickers' OptionLabel, flowing in text. */
export const OrgNameInline = ({ name, parentName }: Pick<OrgNameCellProps, 'name' | 'parentName'>) => (
   <OptionLabel label={name ?? ''} sublabel={parentName} className="inline-flex" />
);

export default OrgNameCell;
